import React from 'react';
import flowImg from '../../images/heart-to-gem.png';
import styles from './onboarding.module.css';

export default function HowItWorks({ name }) {
    return (
        <>
            <div></div> {/* Empty div for centering */}
            <div className={styles.flexDiv} style={{ margin: "0 0.2rem", paddingTop: '2.5rem', gap: '2.5rem' }}>
                <div>
                    <h1 className={styles.onboardingGreeting} style={{ marginTop: '1.5rem', marginBottom: "0.5rem" }}>
                        The guidance is already within you
                    </h1>
                </div>
                <div className={styles.flexDiv} style={{ textAlign: "center", gap: '1.5rem' }}>
                    <p className={styles.para}>
                        Your body sends signals through emotion about what you need and what you value.
                        {/* Emotions are <b>signals from your body</b> about what you need and what you value. */}
                    </p>
                    <div>
                        <img src={flowImg} alt='A heart that leads to a gem' height={80} />
                    </div>
                    <p className={styles.para}>
                        We help you <strong>notice and follow</strong> the signs with a process called <strong>Flows</strong>.
                        {/* a supportive <span style={{ whiteSpace: 'nowrap' }}>micro-journaling</span> process called <b>Flows</b>. */}
                    </p>
                </div>
            </div>
        </>
    );
}
